
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "common/LayoutContainers/DashboardLayout";
import DashboardNavbar from "common/Navbars/DashboardNavbar";
import Footer from "common/Footer";
import DataTable from "common/Tables/DataTable";
import shiftsTableData from "layouts/tables/data/shiftsTableData";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getPendingAccounts, pendingAction } from "store/slice/dealersSlice";
import { Modal, Button, Typography, Box, Alert, Snackbar } from "@mui/material";
import ShiftModal from "./modal";
import { getStudios } from "store/slice/studiosSlice";
import { useNavigate } from "react-router-dom";
import { getShiftHistory } from "store/slice/shiftsSlice";
import { shiftDelete } from "store/slice/shiftsSlice";

function ShiftGeneration() {
    const dispatch = useDispatch();
    const [isShiftModalOpen, setIsShiftModalOpen] = useState(false);
    const dealers = useSelector((store) => store.dealers);
    const shiftStore = useSelector((store) => store.shift);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [dealerToReject, setDealerToReject] = useState(null);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [snackbarSeverity, setSnackbarSeverity] = useState("success");
    const navigate = useNavigate();

    const openShiftGeneration = () => {
        setIsShiftModalOpen(true);
    };

    const closeShiftGeneration = () => {
        setIsShiftModalOpen(false);
    };

    useEffect(() => {
        dispatch(getShiftHistory());
    }, [dispatch]);

    const handleViewClick = (shiftConf) => {
        navigate('/shiftGeneration/'+shiftConf.id)
    };
    
    const handleDeleteClick = (shiftConf) => {
        dispatch(shiftDelete(shiftConf.id))
    };

    const handleModalClose = () => {
        setIsShiftModalOpen(false);
        setDealerToReject(null);
    };

    const handleSnackbarClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setSnackbarOpen(false);
    };
    const tableData = shiftsTableData({
        history: shiftStore?.history || [],
        dispatch,
        handleViewClick,
        handleDeleteClick,
    });

    useEffect(() => {
        dispatch(getStudios())
    }, [])

    useEffect(() => {
        if (Object.keys(shiftStore.shift).length && shiftStore.generateNew) {
            navigate('/shiftGeneration/new')
        }
    }, [shiftStore.generateNew])

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <MDBox pt={6} pb={3}>
                <Grid container spacing={6}>
                    <Grid item size={{xs: 12}}>
                        <Card>
                            <MDBox
                                mx={2}
                                mt={-3}
                                py={3}
                                px={2}
                                variant="gradient"
                                bgColor="info"
                                borderRadius="lg"
                                coloredShadow="info"
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                            >
                                <MDTypography variant="h6" color="white">
                                    Shift Generation
                                </MDTypography>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={openShiftGeneration}
                                >
                                    Generate shift
                                </Button>
                            </MDBox>
                            <MDBox pt={3}>
                                <DataTable
                                    table={tableData}
                                    isSorted={false}
                                    entriesPerPage={false}
                                    showTotalEntries={false}
                                    noEndBorder
                                />
                            </MDBox>
                        </Card>
                    </Grid>
                </Grid>
            </MDBox>
           
            <Snackbar
                open={snackbarOpen}
                autoHideDuration={6000}
                onClose={handleSnackbarClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            >
                <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: "100%" }}>
                    {snackbarMessage}
                </Alert>
            </Snackbar>
            <ShiftModal 
                isShiftModalOpen={isShiftModalOpen}
                handleModalClose={handleModalClose}
                dealerToReject={dealerToReject}
            />
            <Footer />
        </DashboardLayout>
    );
}

export default ShiftGeneration;